import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { setPasswordRequest, verifyToken } from 'utils/api/users';
import SetPasswordForm from 'components/SetPasswordForm/SetPasswordForm';
import { FormValues } from './types';
import Success from 'components/Statuses/Success';
import { login } from 'routes/routePaths';

interface RouteParams {
  token: string;
}

const ResetPasswordPage: React.FC<RouteComponentProps<RouteParams>> = ({ match }) => {
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [validToken, setValidToken] = useState<boolean>(false);
  const { token } = match.params;

  const history = useHistory();

  const handleBack = () => history.push(login);

  useEffect(() => {
    const token = history.location.pathname.split('/')[3];
    const getData = async () => {
      const response = await verifyToken(token);
      setValidToken(response.status === 204);
    };
    getData();
  });

  const handleSubmit = async (values: FormValues) => {
    try {
      const payload = {
        password: values.password,
        repeated_password: values.confirmPassword,
        token,
      };

      await setPasswordRequest(payload);
      setSubmitted(true);
    } catch (error) {}
  };

  return submitted ? (
    <Success message={'Your password has now been set'} onConfirm={handleBack} />
  ) : validToken ? (
    <div className="reset-form">
      <h2 className="plum centered padding-bottom">Password</h2>
      <SetPasswordForm
        onSubmit={handleSubmit}
        labels={{
          password: 'Password',
          confirmPassword: 'Confirm Password',
          submitLabel: 'Set Password',
        }}
      />
    </div>
  ) : (
    <Success
      message={'Sorry, this link to set your password has now expired.'}
      additionalMessage={'A new link has been sent to you. Please check your inbox and click the new link.'}
      onConfirm={handleBack}
    />
  );
};

export default ResetPasswordPage;
